/**
 *
 * FlashCardDetail
 *
 */

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
//import _ from 'lodash';
import $ from 'jquery';
import Swal from 'sweetalert2';

import Spinner from '@/components/Spinner.vue';
import FlashCard from '@/views/FlashCard/FlashCardDetail/components/FlashCard/FlashCard.vue';
import FlashCardFooter from '@/views/FlashCard/FlashCardDetail/components/FlashCardFooter/FlashCardFooter.vue';
import FlashCardHeader from '@/views/FlashCard/FlashCardDetail/components/FlashCardHeader/FlashCardHeader.vue';
import DebugPanel from '@/views/FlashCard/FlashCardDetail/components/DebugPanel.vue';
import FlashCardFilter from '@/views/FlashCard/FlashCardDetail/components/FlashCardFilter.vue';
import FlashCardReport from '@/views/FlashCard/FlashCardDetail/components/FlashCardReport.vue';
import FlashCardSheet from '@/views/FlashCard/FlashCardDetail/components/FlashCardSheet.vue';
import FlashCardStartBtn from '@/views/FlashCard/FlashCardDetail/components/FlashCardStartBtn.vue';
import { FlashCardExerciseTypeMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardExerciseTypeMixin';
import { FlashCardFilterCheckMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardFilterCheckMixin';
import { FlashCardFilterSwitchMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardFilterSwitchMixin';

import * as constants from './FlashCardDetail.constants';

const CardModalMixin = {
  name: 'CardModalMixin',

  data: () => {
    return {
      $flashCardDetailModal: null,
    };
  },

  methods: {
    showCardModal() {
      this.$flashCardDetailModal.modal('show');
    },

    hideCardModal() {
      this.$flashCardDetailModal.modal('hide');
    },

    //
    closeCardModal() {
      //
    },

    onCardModalHidden() {
      //
    },
  },

  mounted() {
    this.$flashCardDetailModal = $(this.$refs.flashCardDetailModal);
    this.$flashCardDetailModal.on('hidden.bs.modal', this.onCardModalHidden);
  },

  beforeDestroy() {
    this.hideCardModal();
  },
};

// FlashCardExerciseTypeMixin
const GetBookFlashCardInfoMixin = {
  name: 'GetBookFlashCardInfoMixin',

  data: () => {
    return {
      promiseGetBookFlashCardInfo: null,
    };
  },

  methods: {
    ...mapActions('FlashCard/FlashCardDetail', {
      ma_getBookFlashCardInfo: 'getBookFlashCardInfo',
    }),

    getBookFlashCardInfo() {
      this.promiseGetBookFlashCardInfo = this.ma_getBookFlashCardInfo({
        courseId: this.$route.params.courseId,
        bookId: this.$route.params.bookId,
      });
    },
  },

  created() {
    if (!this.c_isCourseFavoriteFlashCardExerciseType) {
      this.getBookFlashCardInfo();
    }
  },
};

// FlashCardExerciseTypeMixin
// GetBookFlashCardInfoMixin
const GetBookFlashCardFilterMixin = {
  name: 'GetBookFlashCardFilterMixin',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
    }),
  },

  methods: {
    ...mapActions('FlashCard/FlashCardDetail', {
      ma_getBookFlashCardFilter: 'getBookFlashCardFilter',
    }),

    async getBookFlashCardFilter() {
      await this.promiseGetBookFlashCardInfo;
      this.ma_getBookFlashCardFilter({
        cardId: this.ms_flashCardInfo.cardId,
      });
    },
  },

  created() {
    if (!this.c_isCourseFavoriteFlashCardExerciseType) {
      this.getBookFlashCardFilter();
    }
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterSwitchMixin
const GetFlashCardDetailMixin = {
  name: 'GetFlashCardDetailMixin',

  data: () => {
    return {
      isAddQuestion: true,
    };
  },

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_idxCard: 'idxCard',
      ms_flashCardDetail: 'flashCardDetail',
    }),

    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_selectedFlashCardList: 'selectedFlashCardList',
    }),

    c_isAddQuestion() {
      return (
        this.c_isAddQuestionFlashCardExerciseType &&
        this.c_flashCardFilterSwitch &&
        this.isAddQuestion
      );
    },
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_IDX_CARD: 'SET_IDX_CARD',
    }),

    ...mapActions('FlashCard/FlashCardDetail', {
      ma_getFlashCardDetail: 'getFlashCardDetail',
    }),

    resetFlashCard() {
      //
    },

    async getFlashCardDetail() {
      await this.ma_getFlashCardDetail({
        readingId: this.mg_selectedFlashCardList.readingId,
        cardDetailId: this.mg_selectedFlashCardList.cardDetailId,
        addQuestion: this.c_isAddQuestion,
      });
      this.resetFlashCard();
    },

    async getNthFlashCardDetail(idxCard) {
      this.mm_SET_IDX_CARD(idxCard);
      await this.getFlashCardDetail();
    },

    async getFirstFlashCardDetail() {
      await this.getNthFlashCardDetail(0);
    },

    async getNextFlashCardDetail() {
      let idxCard = this.ms_idxCard;
      if (!this.ms_flashCardDetail.addQuestion) {
        idxCard++;
      }
      await this.getNthFlashCardDetail(idxCard);
    },
  },
};

const ToggleFavoriteFlashCardMixin = {
  name: 'ToggleFavoriteFlashCardMixin',

  data: () => {
    return {
      promiseToggleFavoriteFlashCard: null,
    };
  },

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardDetail: 'flashCardDetail',
    }),
  },

  methods: {
    ...mapActions('FlashCard/FlashCardDetail', {
      ma_toggleFavoriteFlashCard: 'toggleFavoriteFlashCard',
    }),

    async toggleFavoriteFlashCard() {
      this.promiseToggleFavoriteFlashCard = this.ma_toggleFavoriteFlashCard({
        cardId: this.ms_flashCardDetail.cardId,
        cardDetailId: this.ms_flashCardDetail.cardDetailId,
        readingId: this.ms_flashCardDetail.readingId,
        favorite: !this.ms_flashCardDetail.favorite,
      });
      await this.promiseToggleFavoriteFlashCard;
      Swal.fire({
        width: '400px',
        backdrop: false,
        type: 'success',
        icon: 'success',
        title: this.ms_flashCardDetail.favorite ? '已收藏' : '已取消收藏',
        showConfirmButton: false,
        timer: 4000,
      });
    },
  },
};

const ToggleFlashCardAnswerMixin = {
  name: 'ToggleFlashCardAnswerMixin',

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_IS_SHOW_ANSWER: 'SET_IS_SHOW_ANSWER',
    }),

    hideAnswer() {
      this.mm_SET_IS_SHOW_ANSWER(false);
    },
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterSwitchMixin
// CardModalMixin
// GetFlashCardDetailMixin
const AnswerFlashCardMixin = {
  name: 'AnswerFlashCardMixin',

  data: () => {
    return {
      promiseAnswerFlashCard: null,
    };
  },

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardDetail: 'flashCardDetail',
      ms_res_answerFlashCard: 'res_answerFlashCard',
    }),

    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_isLastCard: 'isLastCard',
    }),
  },

  methods: {
    ...mapActions('FlashCard/FlashCardDetail', {
      ma_answerFlashCard: 'answerFlashCard',
    }),

    async answerFlashCard(answer) {
      this.promiseAnswerFlashCard = this.ma_answerFlashCard({
        cardDetailId: this.ms_flashCardDetail.cardDetailId,
        readingId: this.ms_flashCardDetail.readingId,
        answer,
        isWebSeqAnswer: this.c_isSequenceFlashCardExerciseType ? true : undefined,
        isWebSeqLast: this.mg_isLastCard ? true : undefined,
      });
      if (!this.mg_isLastCard) {
        this.getNextFlashCardDetail();
      } else {
        await Swal.fire({
          width: '400px',
          backdrop: false,
          title: `所选范围内卡片都已完成`,
          showConfirmButton: true,
        });
        this.closeCardModal();
      }
      await this.promiseAnswerFlashCard;
      if (false === this.ms_res_answerFlashCard) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          type: 'warning',
          icon: 'warning',
          title: '系统错误',
          showConfirmButton: false,
          timer: 4000,
        });
      }
    },
  },
};

const FlashCardReportMixin = {
  name: 'FlashCardReportMixin',

  components: {
    FlashCardReport,
  },

  methods: {
    clearFlashCardReport() {
      this.$refs.FlashCardReport.clearFlashCardReport();
    },
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterSwitchMixin
// GetFlashCardDetailMixin
const FlashCardSheetMixin = {
  name: 'FlashCardSheetMixin',

  components: {
    FlashCardSheet,
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    gotoSheetCard(idxCard) {
      this.isAddQuestion = false;
      this.getNthFlashCardDetail(idxCard);
      this.isAddQuestion = true;
      this.mm_SET_MODAL_CARD_TYPE('');
    },
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterSwitchMixin
// CardModalMixin
// GetFlashCardDetailMixin
const CourseFavoritePageMixin = {
  name: 'CourseFavoritePageMixin',

  methods: {
    ...mapActions('FlashCard/FlashCardDetail', {
      ma_getFavoriteCourseFlashCardList: 'getFavoriteCourseFlashCardList',
    }),

    async getFavoriteCourseFlashCardList() {
      await this.ma_getFavoriteCourseFlashCardList({
        courseId: this.$route.params.courseId,
      });
    },

    async startCourseFavoritePageFlashCardList() {
      await this.getFavoriteCourseFlashCardList();
      this.getFirstFlashCardDetail();
    },
  },

  created() {
    if (this.c_isCourseFavoriteFlashCardExerciseType) {
      this.startCourseFavoritePageFlashCardList();
    }
  },

  mounted() {
    if (this.c_isCourseFavoriteFlashCardExerciseType) {
      this.showCardModal();
    }
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterCheckMixin
// FlashCardFilterSwitchMixin
// CardModalMixin
// GetFlashCardDetailMixin
const SequenceFlashCardListMixin = {
  name: 'SequenceFlashCardListMixin',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
    }),

    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_isHaveLastStudy: 'isHaveLastStudy',
      mg_lastStudyCardIdx: 'lastStudyCardIdx',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_CARD_EXERCISE_TYPE: 'SET_CARD_EXERCISE_TYPE',
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    ...mapActions('FlashCard/FlashCardDetail', {
      ma_sequenceFlashCardList: 'sequenceFlashCardList',
    }),

    async sequenceFlashCardList() {
      await this.ma_sequenceFlashCardList({
        cardId: this.ms_flashCardInfo.cardId,
        readingIds: JSON.stringify(this.c_checkedFilterReadingIds),
        addQuestion: this.c_flashCardFilterSwitch,
      });
    },

    async sequenceFlashCardListFromBeginning() {
      await this.sequenceFlashCardList();
      this.getFirstFlashCardDetail();
      this.mm_SET_MODAL_CARD_TYPE('');
    },

    async sequenceFlashCardListFromLastStudy() {
      await this.sequenceFlashCardList();
      this.getNthFlashCardDetail(this.mg_lastStudyCardIdx + 1);
    },

    async startSequenceFlashCardList() {
      this.mm_SET_CARD_EXERCISE_TYPE('sequence');
      if (this.mg_isHaveLastStudy) {
        Swal.fire({
          title: '是否继续之前的顺序练习',
          //text: '您已经累计连续学习了60分钟啦！',
          type: 'success',
          showCancelButton: true,
          confirmButtonText: '继续学习',
          cancelButtonText: '重新开始',
          cancelButtonColor: '#dc3545',
        }).then((result) => {
          this.showCardModal();
          if (result.value) {
            this.sequenceFlashCardListFromLastStudy();
          } else {
            this.unCheckAllReadings();
            this.mm_SET_MODAL_CARD_TYPE('filter');
          }
        });
      } else {
        this.showCardModal();
        this.mm_SET_MODAL_CARD_TYPE('filter');
      }
    },
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterCheckMixin
// FlashCardFilterSwitchMixin
// CardModalMixin
// GetFlashCardDetailMixin
const RandomFlashCardListMixin = {
  name: 'RandomFlashCardListMixin',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_CARD_EXERCISE_TYPE: 'SET_CARD_EXERCISE_TYPE',
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
    }),

    ...mapActions('FlashCard/FlashCardDetail', {
      ma_randomFlashCardList: 'randomFlashCardList',
    }),

    async randomFlashCardList() {
      await this.ma_randomFlashCardList({
        cardId: this.ms_flashCardInfo.cardId,
        readingIds: JSON.stringify(this.c_checkedFilterReadingIds),
        addQuestion: this.c_flashCardFilterSwitch,
      });
    },

    async randomFlashCardListFromBeginning() {
      await this.randomFlashCardList();
      this.getFirstFlashCardDetail();
      this.mm_SET_MODAL_CARD_TYPE('');
    },

    startRandomFlashCardList() {
      this.mm_SET_CARD_EXERCISE_TYPE('random');
      this.showCardModal();
      this.mm_SET_MODAL_CARD_TYPE('filter');
    },
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterSwitchMixin
// CardModalMixin
// GetFlashCardDetailMixin
const ReviseFlashCardListMixin = {
  name: 'ReviseFlashCardListMixin',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_CARD_EXERCISE_TYPE: 'SET_CARD_EXERCISE_TYPE',
    }),

    ...mapActions('FlashCard/FlashCardDetail', {
      ma_getReviseFlashCardList: 'getReviseFlashCardList',
    }),

    async getReviseFlashCardList() {
      await this.ma_getReviseFlashCardList({
        cardId: this.ms_flashCardInfo.cardId,
      });
    },

    async startReviseFlashCardList() {
      if (0 === this.ms_flashCardInfo.reviseCount) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          type: 'warning',
          icon: 'warning',
          title: '没有待复习的卡片！',
          showConfirmButton: false,
          timer: 4000,
        });
      } else {
        this.mm_SET_CARD_EXERCISE_TYPE('revise');
        this.showCardModal();
        await this.getReviseFlashCardList();
        this.getFirstFlashCardDetail();
      }
    },
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterSwitchMixin
// CardModalMixin
// GetFlashCardDetailMixin
const FavoriteFlashCardListMixin = {
  name: 'FavoriteFlashCardListMixin',

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_CARD_EXERCISE_TYPE: 'SET_CARD_EXERCISE_TYPE',
    }),

    ...mapActions('FlashCard/FlashCardDetail', {
      ma_getFavoriteFlashCardList: 'getFavoriteFlashCardList',
    }),

    async getFavoriteFlashCardList() {
      await this.ma_getFavoriteFlashCardList({
        cardId: this.ms_flashCardInfo.cardId,
      });
    },

    async startFavoriteFlashCardList() {
      if (0 === this.ms_flashCardInfo.favoriteCount) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          type: 'warning',
          icon: 'warning',
          title: '没有收藏的卡片！',
          showConfirmButton: false,
          timer: 4000,
        });
      } else {
        this.mm_SET_CARD_EXERCISE_TYPE('favorite');
        this.showCardModal();
        await this.getFavoriteFlashCardList();
        this.getFirstFlashCardDetail();
      }
    },
  },
};

// FlashCardExerciseTypeMixin
// FlashCardFilterCheckMixin
// FlashCardFilterSwitchMixin
// CardModalMixin
// GetFlashCardDetailMixin
// SequenceFlashCardListMixin
// RandomFlashCardListMixin
const FlashCardFilterMixin = {
  name: 'FlashCardFilterMixin',

  components: {
    FlashCardFilter,
  },

  methods: {
    filterReading() {
      if (this.c_isSequenceFlashCardExerciseType) {
        this.sequenceFlashCardListFromBeginning();
      } else if (this.c_isRandomFlashCardExerciseType) {
        this.randomFlashCardListFromBeginning();
      }
    },
  },
};

export default {
  name: 'FlashCardDetail',

  mixins: [
    //
    FlashCardExerciseTypeMixin,
    FlashCardFilterCheckMixin,
    FlashCardFilterSwitchMixin,
    CardModalMixin,
    GetBookFlashCardInfoMixin,
    GetBookFlashCardFilterMixin,
    GetFlashCardDetailMixin,
    ToggleFavoriteFlashCardMixin,
    ToggleFlashCardAnswerMixin,
    AnswerFlashCardMixin,
    FlashCardReportMixin,
    FlashCardSheetMixin,
    CourseFavoritePageMixin,
    SequenceFlashCardListMixin,
    RandomFlashCardListMixin,
    ReviseFlashCardListMixin,
    FavoriteFlashCardListMixin,
    FlashCardFilterMixin,
  ],

  components: {
    Spinner,
    FlashCard,
    FlashCardFooter,
    FlashCardHeader,
    DebugPanel,
    FlashCardStartBtn,
  },

  data: () => {
    return {
      loadingMessage: constants.LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardInfo: 'flashCardInfo',
      ms_flashCardDetail: 'flashCardDetail',
    }),

    ...mapGetters('FlashCard/FlashCardDetail', {
      mg_isNoCard: 'isNoCard',
      mg_isRequest: 'isRequest',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_CARD_EXERCISE_TYPE: 'SET_CARD_EXERCISE_TYPE',
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
      mm_SET_BOOK_FLASH_CARD_LIST: 'SET_BOOK_FLASH_CARD_LIST',
      mm_SET_IDX_CARD: 'SET_IDX_CARD',
      mm_SET_FLASH_CARD_DETAIL: 'SET_FLASH_CARD_DETAIL',
    }),

    goBack() {
      this.$router.go(-1);
    },

    ///
    async closeCardModal() {
      await this.promiseAnswerFlashCard;
      await this.promiseToggleFavoriteFlashCard;
      this.hideCardModal();
      if (this.c_isCourseFavoriteFlashCardExerciseType) {
        this.goBack();
      } else {
        if (this.c_isRandomFlashCardExerciseType) {
          this.unCheckAllReadings();
        }
        this.getBookFlashCardInfo();
        this.getBookFlashCardFilter();
        this.mm_SET_BOOK_FLASH_CARD_LIST([]);
        this.mm_SET_FLASH_CARD_DETAIL({});
      }
    },

    ///
    resetFlashCard() {
      this.hideAnswer();
      this.clearFlashCardReport();
    },

    ///
    onCardModalHidden() {
      this.mm_SET_CARD_EXERCISE_TYPE('');
      this.mm_SET_MODAL_CARD_TYPE('');
      this.mm_SET_IDX_CARD(0);
      this.resetFlashCard();
    },
  },
};
